export const WORKFLOW_ARTIFACT_TYPE = 'workflow' as const;

/** Which workflow builder panel to show when the artifact opens. */
export type WorkflowArtifactTab = 'workflow' | 'runs';

/** Payload stored on workflow artifacts (`data` / `payload`). */
export type WorkflowArtifactData = {
  workflowId: string;
  tab?: WorkflowArtifactTab;
  isNew?: boolean;
};
